import React from "react";
import GameInstructionModal from "./GameInstructionModal";

const ModalPingPong = ({ isOpen, onRequestClose }) => {
  return (
    <GameInstructionModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title="Ping Pong"
      gamePath="/userDashboard/game/ping-pong"
      icon="solar:ping-pong-bold"
      instructions={[
        "Patch your better eye.",
        "Control your paddle by moving the mouse to hit the ball back to the computer's side.",
        "Score points by making the computer miss the ball."
      ]}
      isBinocular={false}
    />
  );
};

export default ModalPingPong;
